/**
 * Haptic feedback utility for mobile interactions
 * Uses the Vibration API if supported by the browser.
 */

// Centralize checking to avoid errors on unsupported devices
const isVibrationSupported = typeof navigator !== 'undefined' && 'vibrate' in navigator;

/**
 * Trigger a short, light haptic pop
 * Useful for clicking buttons, tabs, or general interactions
 */
export const triggerLightHaptic = () => {
    if (isVibrationSupported) {
        navigator.vibrate(15); // Light tick
    }
};

/**
 * Trigger a medium haptic thud
 * Useful for opening modals, heavy clicks, or completing actions
 */
export const triggerMediumHaptic = () => {
    if (isVibrationSupported) {
        navigator.vibrate(40); // Medium thud
    }
};

/**
 * Trigger a heavy/success haptic feedback (double pop)
 * Useful for success states or major action triggers (e.g. Long Press)
 */
export const triggerHeavyHaptic = () => {
    if (isVibrationSupported) {
        navigator.vibrate([20, 30, 20]); // Pop-pause-pop
    }
};

/**
 * Legacy/Alternative export to support other components
 * that expect `import { triggerHaptic } from ...`
 */
export const triggerHaptic = {
    light: triggerLightHaptic,
    medium: triggerMediumHaptic,
    heavy: () => {
        if (isVibrationSupported) navigator.vibrate([40, 50, 40]);
    },
    success: triggerHeavyHaptic // Pop-pause-pop is good for success
};
